<template>
<div id="item-type" class="item-type" v-if="itemList !== null">
  <Header />

  <div id="header-navi" class="header-navi">
    <router-link to="/" class="header-navi__back">Back</router-link>
    <h2 class="header-navi__ttl">SELECT TYPE</h2>
  </div>

  <div class="item-type__brand">
    <img :src="itemList[0].brandMainImage" :alt="itemList[0].brandName" />
  </div>
  <div class="item-type__select">
    <h2 class="item-type__select__ttl">SELECT TYPE</h2>
    <p v-if="itemList[0].brandName === 'LONGCHAMP'" class="item-type__select__txt">コレクションを見る</p>
    <p v-else class="item-type__select__txt">カスタムしたい商品を選択してください</p>
  </div>
  <div class="item-type__items">
    <div class="item-type__items__ct">

      <router-link
        v-for="item in itemList"
        :key="item.id"
        v-if="item.isDev !== true"
        :to="{ name: 'item-detail', params: { brandID: brandID, id: item.id } }"
        class="item-type__items__ct__item">
        <div class="item-type__items__ct__item__img">
          <img :src="item.mainImage[0]" alt="item" />
        </div>
        <p class="item-type__items__ct__item__ttl">{{ item.name }}</p>
      </router-link>

    </div>
  </div>
  <Footer />
</div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import customMgr from '@/modules/CustomManager.js'

export default {
  components: {
    Header,
    Footer
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getAllItems(
      Number(to.params.brandID),
      'web'
    ).then((itemList) => {
      if (itemList.length > 0) {
        next(vm => vm.setItemList(itemList))
      } else {
        next({ name: 'not-found' })
      }
    })
  },
  props: {
    brandID: Number
  },
  data () {
    return {
      itemList: null
    }
  },
  methods: {
    setItemList (itemList) {
      this.itemList = itemList
    }
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}
.item-type {
  &__brand {
    width: 100%;
    height: 80px;
    padding: 20px 50px;
    border-bottom: 1px solid $right-gray;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &__select {
    padding: 40px 0 20px;
    &__ttl {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
    &__txt {
      font-size: 12px;
      text-align: center;
      margin-top: 10px;
    }
  }
  &__items {
    background-color: $right-gray;
    padding: 25px 15px;
    min-height: 47vh;
    &__ct {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      &__item {
        width: calc(50% - 5px);
        background-color: $base-white;
        padding: 15px 10px;
        &:nth-child(n + 3) {
          margin-top: 10px;
        }
        &__img {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 80%;
            object-fit: contain;
          }
        }
        &__ttl {
          text-align: center;
          font-size: 13px;
          font-weight: bold;
          margin-top: 10px;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ItemType.vue